import { render, staticRenderFns } from "./ConfigurationTemplate.vue?vue&type=template&id=8a95d978&scoped=true&"
import script from "./ConfigurationTemplate.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a95d978",
  null
  
)

export default component.exports